
const InfoList = (props) => {
    // console.log(props)

    const listIn = props.listIn
    var count = 0;

    return (
        <div className="info-list">
            <div className="block-title">
                <h6 className="title">کاری که من انجام می دهم</h6>
            </div>
            <div className="row">

                {listIn?.map((item, index) => {
                    count = count + 1;
                    if (count <= 4) {
                        return <div className="col-sm-6" key={index}>
                            <div className="info-list-item">
                                <i className={`far ${item.awesome} `}></i>
                                <div className="title-info">{item.titleInfo}</div>
                                <p className="des">
                                    {item.summaryInfo}
                                </p>
                            </div>
                        </div>
                    }
                }
                )}

            </div>
        </div>
    )
}
export default InfoList;